import { render, staticRenderFns } from "./receipt-detail.vue?vue&type=template&id=0b6bd0de&scoped=true&"
import script from "./receipt-detail.vue?vue&type=script&lang=js&"
export * from "./receipt-detail.vue?vue&type=script&lang=js&"
import style0 from "./receipt-detail.vue?vue&type=style&index=0&id=0b6bd0de&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6bd0de",
  null
  
)

export default component.exports